import { useMutation } from '@/core/hooks/use-mutation'
import { deleteProfileImage } from '../providers/client'
import { UserDetailsModel } from '@/features/auth/types/models/user-details.model'
import { useAuth } from '@/core/store/auth'
import { useRouter } from 'next/navigation'

export const useDeleteProfileImage = ({
  onSuccess,
}: {
  onSuccess?: (user: UserDetailsModel) => void
}) => {
  const { setUser } = useAuth()
  const router = useRouter()
  //   const { user } = useAuth()
  const { mutate, isPending } = useMutation({
    mutation: deleteProfileImage,
    onSuccess(user) {
      setUser(user)
      router.refresh()
      onSuccess?.(user)
    },
  })

  return {
    deleteImage: () => mutate(undefined),
    isDeleting: isPending,
  }
}
